import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import { ApiStatus } from 'common/enums';
import { CommonModals, Footer, Header } from 'common/components';
import { APP_NAME } from 'common/config/app.config';
import useLogin from 'common/hooks/useLogin';
import { RootState } from 'common/redux/core/root.reducer';
import { getAvatar, getUserInfoSelector, getUserName } from 'common/redux/user/user.selector';

import NewUserLayout from './new-user-layout';
import AuthorizedLayout from './authorized-layout';
import GuestLayout from './guest-layout';

const Layout: FC = () => {
    const isAuthReady = useLogin();

    const userInfo = useSelector((state: RootState) => getUserInfoSelector(state));
    const avatar = useSelector((state: RootState) => getAvatar(state));
    const userName = useSelector((state: RootState) => getUserName(state));
    let layout = <GuestLayout />;

    if (
        isAuthReady &&
        userInfo.status === ApiStatus.SUCCESS &&
        userInfo.data &&
        userInfo.data.isValidUser
    ) {
        layout = <AuthorizedLayout />;
    } else if (
        isAuthReady &&
        userInfo.status === ApiStatus.SUCCESS &&
        userInfo.data &&
        !userInfo.data.isValidUser
    ) {
        layout = <NewUserLayout />;
    }

    return (
        <div className="app-layout-container">
            <Header
                appHeaderName={`${APP_NAME}${String.fromCodePoint(0x02122)}`}
                avatar={avatar}
                userName={userName}
            />
            {layout}
            <Footer />
            <CommonModals />
        </div>
    );
};

export default memo(Layout);
